import { Button, Container, List, Pill, Text, Title, rem } from "@mantine/core";
import { IconSettings } from "@tabler/icons-react";
import React from "react";
import { useIncomeFormContext } from "../../context/form-context";
import { useDocumentTitle } from "@mantine/hooks";
import { gbpFormatter } from "../../utils";

type InstructionsContentProps = {};

const InstructionsContent: React.FC<InstructionsContentProps> = () => {
  const form = useIncomeFormContext();
  const [documentTitle, setDocumentTitle] = React.useState<string>(
    "Calculate Income Tax & Take Home Pay - Income-Tax-Calculator.com"
  );
  React.useEffect(() => {
    if (form.values.salary1.grossIncome && !form.values.salary2.grossIncome) {
      const formattedGrossIncome = gbpFormatter(
        form.values.salary1.grossIncome
      );
      setDocumentTitle(
        `${formattedGrossIncome} Tax & Take-home Pay - Income-Tax-Calculator.com`
      );
    } else if (
      form.values.salary1.grossIncome &&
      form.values.salary2.grossIncome
    ) {
      const formattedGrossIncome1 = gbpFormatter(
        form.values.salary1.grossIncome
      );
      const formattedGrossIncome2 = gbpFormatter(
        form.values.salary2.grossIncome
      );
      setDocumentTitle(
        `${formattedGrossIncome1} vs ${formattedGrossIncome2} Tax & Take-home Pay - Income-Tax-Calculator.com`
      );
    }
  }, [form.values.salary1.grossIncome, form.values.salary2.grossIncome]);
  useDocumentTitle(documentTitle);
  return (
    <Container w="80%">
      <Title mt="xl" mb="xl" order={1}>
        Calculate your income tax, pension deductions and take home pay
      </Title>
      <List mb="xl" type="ordered" spacing="lg">
        <List.Item>
          <Text>Enter your salary into the field below.</Text>
        </List.Item>
        <List.Item>
          <Text>
            Press the{" "}
            <Button
              size="xs"
              radius="xl"
              rightSection={
                <IconSettings
                  style={{ width: rem(12), height: rem(12) }}
                  stroke={1.5}
                />
              }
            >
              Configure
            </Button>{" "}
            button to set your tax allowances, deductions, and settings.
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            Compare two salaries by entering a second salary.{" "}
            <Pill>Optional</Pill>
          </Text>
        </List.Item>
      </List>
    </Container>
  );
};

export default InstructionsContent;
